import React from 'react'
import {DonationInput} from '../../../../donation-input'
import {classes} from './donation.st.css'
import {DonationProps} from './interafces'

export const Donation = ({...props}: DonationProps) => <DonationInput {...props} className={classes.root} />
